// La cadena con la que trabaja Inventario: la fija del scope o, si el usuario también es de tenant,
// su única asignación LEVEL_1. Inventario no tiene selector de cadena.
import type { RoleAssignmentInfoLocal } from '@/api/types/MeLocal';
import { resolveRetailerScope } from '@/domains/retail/ventas/lib/retailerScope';

/** Por qué no hay cadena: ninguna asignada o más de una. */
export type InventoryRetailerProblem = 'NONE' | 'MANY';

export interface InventoryRetailer {
    retailerId: string | null;
    problem: InventoryRetailerProblem | null;
}

export function resolveInventoryRetailer(
    assignments: RoleAssignmentInfoLocal[],
): InventoryRetailer {
    const { fixedRetailerId } = resolveRetailerScope(assignments);
    if (fixedRetailerId !== null) return { retailerId: fixedRetailerId, problem: null };
    const retailers = [
        ...new Set(assignments.filter((a) => a.scope === 'LEVEL_1').map((a) => a.scopeRef)),
    ];
    if (retailers.length === 1) return { retailerId: retailers[0], problem: null };
    return { retailerId: null, problem: retailers.length === 0 ? 'NONE' : 'MANY' };
}

const NOTICE: Record<InventoryRetailerProblem, string> = {
    NONE: 'Tu usuario no tiene una cadena asignada, así que no podemos mostrar sus tiendas, productos ni tarjetas. Pide a tu administrador que te asigne la cadena que operas.',
    MANY: 'Tienes varias cadenas asignadas y esta pantalla trabaja con una sola, así que no podemos mostrar sus tiendas, productos ni tarjetas. Pide a tu administrador que te deje solo la cadena que operas.',
};

/** Aviso de la pantalla cuando no hay una sola cadena con la cual trabajar. */
export function inventoryRetailerNotice(problem: InventoryRetailerProblem): string {
    return NOTICE[problem];
}
